export default "__VITE_ASSET__CxJ0WXw9__"